import React from "react";
import classNames from "classnames";

const PageOutline = () => (
  <React.Fragment>
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
    <polyline points="14 3 14 8 19 8" />
  </React.Fragment>
);

const FileTypeIcon = ({ label, className, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={classNames(
      "file-type-icon",
      label && label.toLowerCase(),
      className
    )}
    {...props}
  >
    <PageOutline />
    {label && (
      <text
        x="8"
        y="17"
        fontFamily="Poppins, sans-serif"
        fontSize="5"
        fontWeight="700"
        fill="currentColor"
        stroke="none"
      >
        {label}
      </text>
    )}
  </svg>
);

export default FileTypeIcon;
